class ScGiftBudget extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;

    this.tabs = [...this.querySelectorAll('[data-gift-tab]')];
    this.panels = [...this.querySelectorAll('[data-gift-panel]')];
    this.results = this.querySelector('.sc-gift-budget__results');

    this.tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => this.selectTab(tab));
      tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
    });

    this.updateResultsLayout(this.panels.find((panel) => !panel.hidden));
    this.dataset.ready = 'true';
  }

  selectTab(selectedTab) {
    const selectedBudget = selectedTab.dataset.giftTab;

    this.tabs.forEach((tab) => {
      const isSelected = tab === selectedTab;
      tab.setAttribute('aria-selected', String(isSelected));
      tab.tabIndex = isSelected ? 0 : -1;
    });

    let selectedPanel;
    this.panels.forEach((panel) => {
      const isSelected = panel.dataset.giftPanel === selectedBudget;
      panel.hidden = !isSelected;
      if (isSelected) selectedPanel = panel;
    });

    this.updateResultsLayout(selectedPanel);
  }

  updateResultsLayout(panel) {
    const productCount = panel?.querySelectorAll('.sc-gift-budget__product').length || 0;
    this.results?.classList.toggle('is-compact', productCount > 0 && productCount < 3);
  }

  handleKeydown(event, index) {
    const keyActions = {
      ArrowRight: index + 1,
      ArrowLeft: index - 1,
      Home: 0,
      End: this.tabs.length - 1,
    };

    if (!(event.key in keyActions)) return;

    event.preventDefault();
    const nextIndex = (keyActions[event.key] + this.tabs.length) % this.tabs.length;
    const nextTab = this.tabs[nextIndex];
    nextTab.focus();
    this.selectTab(nextTab);
  }
}

if (!customElements.get('gift-budget')) {
  customElements.define('gift-budget', ScGiftBudget);
}
